import { MutableRefObject, RefObject } from "react"
import dayjs, { Dayjs } from "dayjs"
import timezone from "dayjs/plugin/timezone"
import utc from "dayjs/plugin/utc"
import { filterInt, sortInt } from "@/utils/types/InfiniteTable"
import { TAPIPayload } from "@/utils/store/AppStore.types"

dayjs.extend(utc)
dayjs.extend(timezone)

interface IFilterSort {
  page: number
  filter?: {}
  sort?: {}
  is_filter?: boolean | undefined
  per_page?: number
  offet?: number
}

type TFilterSortExtractor = {
  page: number
  tableRef?: RefObject<HTMLDivElement>
  sortRef?: MutableRefObject<sortInt | {}>
  filterRef?: MutableRefObject<filterInt | {}>
  filterFlag?: boolean
  perPage?: number | "calculate"
}

const FilterSortExtractor = ({ page, tableRef, sortRef, filterRef, filterFlag, perPage }: TFilterSortExtractor): IFilterSort => {
  let sort = {}
  let filter = {}
  let is_filter: boolean | undefined = undefined
  let per_page: number = 20
  var tempFilter: any = { ...filterRef?.current }
  delete tempFilter["start"]
  delete tempFilter["end"]

  // Removes undefined values
  tempFilter = JSON.parse(JSON.stringify(tempFilter))

  if (sortRef?.current && Object.keys(sortRef.current).length > 0) {
    sort = { sort: { ...sortRef.current } }
  }

  if (Object.keys(tempFilter).length > 0) {
    is_filter = true
  } else {
    is_filter = false
  }

  if (filterRef?.current && tempFilter) {
    filter = { ...filterRef.current }
  }

  if (!filterFlag) {
    is_filter = undefined
  }

  if (perPage === "calculate") {
    per_page = calculateNumRecordsToFetch(tableRef)
  } else if (typeof perPage === "number") {
    per_page = perPage
  }

  return {
    page,
    is_filter,
    per_page,
    ...filter,
    ...sort,
  }
}

// This is only used for Guest Request / Purchases Flow //
const FilterSortExtractorPurchase = ({ page, tableRef, sortRef, filterRef, filterFlag, perPage }: TFilterSortExtractor): any => {
  let sort: any = {}
  let filter = {}
  let is_filter: boolean | undefined = undefined
  let per_page: number = 20
  let tempFilter = { ...filterRef?.current }
  delete tempFilter["start"]
  delete tempFilter["end"]

  // Removes undefined values
  tempFilter = JSON.parse(JSON.stringify(tempFilter))

  if (sortRef?.current && Object.keys(sortRef.current).length > 0) {
    sort = { sort: { ...sortRef.current } }
  }

  if (filterRef?.current && tempFilter && Object.keys(tempFilter).length > 0) {
    filter = { ...filterRef.current }
    is_filter = true
  } else {
    is_filter = false
  }

  if (!filterFlag) {
    is_filter = undefined
  }

  if (perPage === "calculate") {
    per_page = calculateNumRecordsToFetch(tableRef)
  } else if (typeof perPage === "number") {
    per_page = perPage
  }

  return {
    page,
    is_filter,
    per_page,
    filters: Object.keys(filter).length > 0 ? filter : undefined,
    ...sort,
  }
}

const calculateNumRecordsToFetch = (tableRef?: RefObject<HTMLDivElement>) => {
  const table = tableRef?.current ? tableRef.current : document.querySelector(".InfiTable")
  if (table) {
    const viewportHeight = table.clientHeight
    const recordRowHeight = 52
    const perPage = Math.ceil(viewportHeight / recordRowHeight)
    return perPage < 20 ? 20 : perPage
  } else {
    return 20
  }
}

const calculateToFromFilter = (value: string): TAPIPayload => {
  const filterRange: TAPIPayload = {}
  // return {}
  const format = "DD-MM-YYYY"
  const todayDate = dayjs().format(format)
  const current = dayjs(todayDate, format).startOf("day")

  if (value === "Today") {
    filterRange.start = current.unix() * 1000
    filterRange.end = current.add(1, "day").unix() * 1000
  } else if (value === "Yesterday") {
    filterRange.start = current.subtract(1, "day").unix() * 1000
    filterRange.end = current.unix() * 1000
  } else if (value === "Tomorrow") {
    filterRange.start = current.add(1, "day").unix() * 1000
    filterRange.end = current.add(2, "days").unix() * 1000
  } else if (value === "This Week") {
    filterRange.start = current.startOf("week").unix() * 1000
    filterRange.end = current.add(1, "day").unix() * 1000
  } else if (value === "Past 15 days") {
    filterRange.start = current.subtract(15, "days").unix() * 1000
    filterRange.end = current.unix() * 1000
  } else {
    filterRange.start = undefined
    filterRange.end = undefined
  }

  return filterRange
}

export { FilterSortExtractor, FilterSortExtractorPurchase, calculateNumRecordsToFetch, calculateToFromFilter }
